import api from 'api';
import type { AnyAction } from 'redux';
import type { Currency } from 'types/account';
import type { Thunk } from 'types/redux';

export const FETCHED = 'timely/currencies/FETCHED';

export type CurrenciesState = Array<Currency>;

export default function reducer(state: CurrenciesState = [], action: AnyAction) {
  if (action.type === FETCHED) {
    return action.payload;
  }
  return state;
}

export function fetchCurrencies(): Thunk {
  return dispatch => {
    return api.getCurrencies().then(currencies => {
      dispatch({ type: FETCHED, payload: currencies });
    });
  };
}
